/*
 * @Descripttion:
 * @version:
 * @Author: your name
 * @Date: 2024-05-23 20:00:16
 * @LastEditors: your name
 * @LastEditTime: 2024-08-20 14:37:14
 */
import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index => require(["@/pages/index"], Index)
      // redirect: '/aboutus',
      // children: [
      //   {
      //     path: '/download',
      //     name: 'Download',
      //     component: Aboutus => require(['@/pages/download'], Aboutus),
      //   },
      //   {
      //     path: '/aboutus',
      //     name: 'Aboutus',
      //     component: Aboutus => require(['@/pages/aboutUs'], Aboutus),
      //   },
      //   {
      //     path: '/contactus',
      //     name: 'Contactus',
      //     component: Aboutus => require(['@/pages/contactUs'], Aboutus),
      //   },
      //   {
      //     path: '/joinus',
      //     name: 'Joinus',
      //     component: Aboutus => require(['@/pages/joinUs'], Aboutus),
      //   },
      // ]
    },
    {
      path: "/account",
      name: "Account",
      component: Account => require(["@/pages/account"], Account)
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js